document.addEventListener('scroll', function(e) {
    // Global Variables For Scroll
    const doc = document.documentElement;
    const docScrollLeft = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0)
    const docScrollTop = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0)

    const navbarOpacity = (docScrollTop * 0.7) / 100

    // NAVBAR STORY INFO
    // const navbarStory = document.querySelector('.navbar-story')
    const navbarTransparent = document.querySelector('.navbar--transparent')
    const navbarTitle = document.querySelector('.navbar__title')
    const storyTitleTop = document.querySelector('.for-title-nav')
    

    // Background & Box Shadow Navbar
    if (docScrollTop < 1) {
        navbarTransparent.style.backgroundColor = 'rgba(255, 255, 255, 0)'
        navbarTransparent.style.boxShadow = '0px 12px 16px -8px rgba(36, 38, 40, 0)'
    } else if (docScrollTop >= 1 && docScrollTop <= 150) {
        navbarTransparent.style.backgroundColor = 'rgba(255, 255, 255, '+navbarOpacity+')'
        navbarTransparent.style.boxShadow = '0px 12px 16px -8px rgba(36, 38, 40, '+ navbarOpacity / 10 +')'
    } else if (docScrollTop > 150) {
        navbarTransparent.style.backgroundColor = 'rgba(255, 255, 255, 1)'
        navbarTransparent.style.boxShadow = '0px 12px 16px -8px rgba(36, 38, 40, 0.1)'
    }

    // Color Text Navbar
    if (docScrollTop >= 50) {
        navbarTransparent.classList.add('-color')
    } else {
        navbarTransparent.classList.remove('-color')
    }

    // Show/hide Title Navbar
    if (docScrollTop >= getOffset(storyTitleTop).top) {
        navbarTitle.classList.add('-show')
    } else {
        navbarTitle.classList.remove('-show')
    }
});